<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form #f="ngForm" (ngSubmit)="save()">
  <div class="modal-header">
    <h5 class="modal-title" [xdaTranslate]="'SDE_EDIT_ROLE'"></h5>
  </div>
  <div class="modal-body" tabindex="-1">
    <xrx-radio
      id="editrole"
      [list]="roles"
      property="value"
      localize="display"
      [(checkedItem)]="selectedRole"></xrx-radio>
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
    </div>
    <div class="cb">
      <button
        type="submit"
        class="xrx-btn btn-primary"
        [disabled]="!f.valid || processing">
        <span class="btn-label" [xdaTranslate]="'SDE_SAVE'"></span>
      </button>
    </div>
  </div>
</form>
